import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useAbortRunCommandV1(
	id?: string | Ref<string> | (() => string), 
	abortReason?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _abortReason = isRef<string>(abortReason) ? abortReason : ref<string>((typeof abortReason === 'function') ? abortReason() : abortReason)

	const result = {
		id: _id,
		abortReason: _abortReason,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof abortReason === 'function') { _abortReason.value = abortReason() }

			return new c.AbortRunCommandV1(_id.value, _abortReason.value)
		})
	}

	return {
		...result,
		authorizedAbortRunCommandV1: result.authorized,
		abortRunCommandV1: result.command,
		completedAbortRunCommandV1: result.completed,
		errorAbortRunCommandV1: result.error,
		invokeAbortRunCommandV1: result.invoke,
		invokingAbortRunCommandV1: result.invoking,
		succeedAbortRunCommandV1: result.succeed,
		validationErrorsAbortRunCommandV1: result.validationErrors,
		onSucceedAbortRunCommandV1: result.onSucceed,
	}
}

export function useAppendRunLogCommandV1(
	id?: string | Ref<string> | (() => string), 
	occuredAt?: any | Ref<any> | (() => any), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	message?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _occuredAt = isRef<any>(occuredAt) ? occuredAt : ref<any>((typeof occuredAt === 'function') ? occuredAt() : occuredAt)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _message = isRef<string>(message) ? message : ref<string>((typeof message === 'function') ? message() : message)

	const result = {
		id: _id,
		occuredAt: _occuredAt,
		organizationUnitId: _organizationUnitId,
		message: _message,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof occuredAt === 'function') { _occuredAt.value = occuredAt() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof message === 'function') { _message.value = message() }

			return new c.AppendRunLogCommandV1(_id.value, _occuredAt.value, _organizationUnitId.value, _message.value)
		})
	}

	return {
		...result,
		authorizedAppendRunLogCommandV1: result.authorized,
		appendRunLogCommandV1: result.command,
		completedAppendRunLogCommandV1: result.completed,
		errorAppendRunLogCommandV1: result.error,
		invokeAppendRunLogCommandV1: result.invoke,
		invokingAppendRunLogCommandV1: result.invoking,
		succeedAppendRunLogCommandV1: result.succeed,
		validationErrorsAppendRunLogCommandV1: result.validationErrors,
		onSucceedAppendRunLogCommandV1: result.onSucceed,
	}
}

export function useCompleteRunCommandV1(
	id?: string | Ref<string> | (() => string), 
	queuedBy?: string | null | Ref<string | null> | (() => string | null), 
	queuedAt?: any | Ref<any> | (() => any), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _queuedBy = isRef<string | null>(queuedBy) ? queuedBy : ref<string | null>((typeof queuedBy === 'function') ? queuedBy() : queuedBy)
	const _queuedAt = isRef<any>(queuedAt) ? queuedAt : ref<any>((typeof queuedAt === 'function') ? queuedAt() : queuedAt)

	const result = {
		id: _id,
		queuedBy: _queuedBy,
		queuedAt: _queuedAt,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof queuedBy === 'function') { _queuedBy.value = queuedBy() }
			if (typeof queuedAt === 'function') { _queuedAt.value = queuedAt() }

			return new c.CompleteRunCommandV1(_id.value, _queuedBy.value, _queuedAt.value)
		})
	}

	return {
		...result,
		authorizedCompleteRunCommandV1: result.authorized,
		completeRunCommandV1: result.command,
		completedCompleteRunCommandV1: result.completed,
		errorCompleteRunCommandV1: result.error,
		invokeCompleteRunCommandV1: result.invoke,
		invokingCompleteRunCommandV1: result.invoking,
		succeedCompleteRunCommandV1: result.succeed,
		validationErrorsCompleteRunCommandV1: result.validationErrors,
		onSucceedCompleteRunCommandV1: result.onSucceed,
	}
}

export function useDeleteRunCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	deletedBy?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _deletedBy = isRef<string>(deletedBy) ? deletedBy : ref<string>((typeof deletedBy === 'function') ? deletedBy() : deletedBy)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		deletedBy: _deletedBy,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof deletedBy === 'function') { _deletedBy.value = deletedBy() }

			return new c.DeleteRunCommandV1(_id.value, _organizationUnitId.value, _deletedBy.value)
		})
	}

	return {
		...result,
		authorizedDeleteRunCommandV1: result.authorized,
		deleteRunCommandV1: result.command,
		completedDeleteRunCommandV1: result.completed,
		errorDeleteRunCommandV1: result.error,
		invokeDeleteRunCommandV1: result.invoke,
		invokingDeleteRunCommandV1: result.invoking,
		succeedDeleteRunCommandV1: result.succeed,
		validationErrorsDeleteRunCommandV1: result.validationErrors,
		onSucceedDeleteRunCommandV1: result.onSucceed,
	}
}

export function useFailRunCommandV1(
	id?: string | Ref<string> | (() => string), 
	failureReason?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _failureReason = isRef<string>(failureReason) ? failureReason : ref<string>((typeof failureReason === 'function') ? failureReason() : failureReason)

	const result = {
		id: _id,
		failureReason: _failureReason,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof failureReason === 'function') { _failureReason.value = failureReason() }

			return new c.FailRunCommandV1(_id.value, _failureReason.value)
		})
	}

	return {
		...result,
		authorizedFailRunCommandV1: result.authorized,
		failRunCommandV1: result.command,
		completedFailRunCommandV1: result.completed,
		errorFailRunCommandV1: result.error,
		invokeFailRunCommandV1: result.invoke,
		invokingFailRunCommandV1: result.invoking,
		succeedFailRunCommandV1: result.succeed,
		validationErrorsFailRunCommandV1: result.validationErrors,
		onSucceedFailRunCommandV1: result.onSucceed,
	}
}

export function usePermanentDeleteRunCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.PermanentDeleteRunCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedPermanentDeleteRunCommandV1: result.authorized,
		permanentDeleteRunCommandV1: result.command,
		completedPermanentDeleteRunCommandV1: result.completed,
		errorPermanentDeleteRunCommandV1: result.error,
		invokePermanentDeleteRunCommandV1: result.invoke,
		invokingPermanentDeleteRunCommandV1: result.invoking,
		succeedPermanentDeleteRunCommandV1: result.succeed,
		validationErrorsPermanentDeleteRunCommandV1: result.validationErrors,
		onSucceedPermanentDeleteRunCommandV1: result.onSucceed,
	}
}

export function useQueueRunCommandV1(
	id?: string | Ref<string> | (() => string), 
	organizationUnitId?: string | Ref<string> | (() => string), 
	pipelineId?: string | Ref<string> | (() => string), 
	queuedBy?: string | null | Ref<string | null> | (() => string | null), 
	trigger?: string | Ref<string> | (() => string), 
	triggerData?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>((typeof organizationUnitId === 'function') ? organizationUnitId() : organizationUnitId)
	const _pipelineId = isRef<string>(pipelineId) ? pipelineId : ref<string>((typeof pipelineId === 'function') ? pipelineId() : pipelineId)
	const _queuedBy = isRef<string | null>(queuedBy) ? queuedBy : ref<string | null>((typeof queuedBy === 'function') ? queuedBy() : queuedBy)
	const _trigger = isRef<string>(trigger) ? trigger : ref<string>((typeof trigger === 'function') ? trigger() : trigger)
	const _triggerData = isRef<string>(triggerData) ? triggerData : ref<string>((typeof triggerData === 'function') ? triggerData() : triggerData)

	const result = {
		id: _id,
		organizationUnitId: _organizationUnitId,
		pipelineId: _pipelineId,
		queuedBy: _queuedBy,
		trigger: _trigger,
		triggerData: _triggerData,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }
			if (typeof organizationUnitId === 'function') { _organizationUnitId.value = organizationUnitId() }
			if (typeof pipelineId === 'function') { _pipelineId.value = pipelineId() }
			if (typeof queuedBy === 'function') { _queuedBy.value = queuedBy() }
			if (typeof trigger === 'function') { _trigger.value = trigger() }
			if (typeof triggerData === 'function') { _triggerData.value = triggerData() }

			return new c.QueueRunCommandV1(_id.value, _organizationUnitId.value, _pipelineId.value, _queuedBy.value, _trigger.value, _triggerData.value)
		})
	}

	return {
		...result,
		authorizedQueueRunCommandV1: result.authorized,
		queueRunCommandV1: result.command,
		completedQueueRunCommandV1: result.completed,
		errorQueueRunCommandV1: result.error,
		invokeQueueRunCommandV1: result.invoke,
		invokingQueueRunCommandV1: result.invoking,
		succeedQueueRunCommandV1: result.succeed,
		validationErrorsQueueRunCommandV1: result.validationErrors,
		onSucceedQueueRunCommandV1: result.onSucceed,
	}
}

export function useStartRunCommandV1(
	id?: string | Ref<string> | (() => string), 
) 
{
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		id: _id,

		...useCommand(() => {
			if (typeof id === 'function') { _id.value = id() }

			return new c.StartRunCommandV1(_id.value)
		})
	}

	return {
		...result,
		authorizedStartRunCommandV1: result.authorized,
		startRunCommandV1: result.command,
		completedStartRunCommandV1: result.completed,
		errorStartRunCommandV1: result.error,
		invokeStartRunCommandV1: result.invoke,
		invokingStartRunCommandV1: result.invoking,
		succeedStartRunCommandV1: result.succeed,
		validationErrorsStartRunCommandV1: result.validationErrors,
		onSucceedStartRunCommandV1: result.onSucceed,
	}
}

